module.exports = {
    dashboard: "Nástenka",
    voltage_profile: "Napäťový profil",
    current_profile: "Prúdový profil",
    active_power_profile: "Činný výkonový profil",
    reactive_power_profile: "Jalový výkonový profil",
    apparent_power_profile: "Zdanlivý výkonový profil",
    energy_import_profile: "Profil odberu energie",
    energy_export_profile: "Profil dodávky energie",
    realtime_voltage: "Napäťový profil v reálnom čase",
    realtime_current: "Prúdový profil v reálnom čase",
    realtime_active_power: "Činný výkonový profil v reálnom čase",
    realtime_reactive_power: "Jalový výkonový profil v reálnom čase",
    realtime_apparent_power: "Zdanlivý výkonový profil v reálnom čase",
    realtime_energy_import_profile: "Odber energie v reálnom čase",
    realtime_energy_export_profile: "Dodávka energie v reálnom čase",
    hourly_active_energy: "Hodinová činná energia",
    daily_active_energy: "Denná činná energia",
    monthly_active_energy: "Mesačná činná energia",
    hourly_reactive_energy: "Hodinová jalová energia",
    daily_reactive_energy: "Denná jalová energia",
    monthly_reactive_energy: "Mesačná jalová energia",
    appliances_imprints: "Odtlačky spotrebičov",
    appliances_energy: "Energia odobratá spotrebičmi",
    appliances_timeline: "Časová os spotrebičov",
    appliances_run_profile: "Činný výkonový profil so spotrebičmi",
    imprints_map: "Mapa odtlačkov spotrebičov",
    edit_profile: "Správa profilu",
    dashboard_settings: "Nastavenia informačného panela",
    statistics_report: "Štatistický report",
    graphs_types: "Typy grafov",
    active_energy_report: "Správa o aktívnej energii",
    reactive_energy_report: "Správa o jalovej energii",
    location: "Umiestnenia",
    local_change_password: "Zmena lokálneho hesla",
    monitoring: "Monitorovanie dostupnosti",
    phase_selection: "Voľba fázy",
    appliance_properties: "Vlastnosti spotrebiča",
    energy_edit: "Úprava energie",
    dashboard_merito_recognition: "Nástenka",
    dashboard_disconnector: "Nástenka Disconnector",
    dashboard_precision: "Nástenka Applied Precision",
    disconnector_timeline: "Časová os",
    disconnector_energy_profile: "Energeticky profil",
    lora_settings: "Nastavenia LoRa",
    basic: "Základné",
    details: "Podrobnosti",
    data: "Dáta",
    basic_settinsg: "Základné nastavenia",
    details_settings: "Podrobné nastavenia",
    data_structure_settinsg: "Nastavenia dátovej štruktúry",
    timers: "Časovače",
    energy_scalers: "Škály energií",
    radio: "Rádio",
    create_first_test_case: "Pridaj prvý testovací prípad",
    add_new_test_case: "Pridaj nový testovací prípad",
    edit_test_case: "Uprav testovací prípad",
    generator: "Generátor",
    test_conditions: "Testovacie podmienky",
    accutest_profile: "Testovací profil",
    no_test_was_performed: "Nebol vykonaný žiaden test",
    test_case: "Testovaci prípad",
    relative_error_chart: "Graf relatívnej odchýlky všetkých testovacích prípadov",
    accutest_results: "Výsledky testov",
    accutest_testing: "Proces testovania",
    start_testing_process: "Spusti proces testovania",
    test_case_result: "Výsledok testovacieho prípadu",
    testing_in_progress: "Testovanie prebieha",
    start_another_testing_process: "Spusti ďalší testovací proces",
    integration: "Integrácia",
    generated: "Generovaný",
    expiration: "Expirácia",
    token: "Token",
    note: "Poznámka",
    token_validity: "Platnosť tokenu",
    valid_tokens: "Platné tokeny",
    invalid_tokens: "Neplatné tokeny",
    generate_first_token: "Generovať prvý token",
    active_energy_15min: "Činná energia za 15 minút",
    maximum_active_energy_15min: "Maximum činného výkonu za 15 minút",
    wifi_settings: "Nastavenia WiFi",
    device_settings: "Nastavenia zariadenia",
    report: "Aplikácia report",
    controller_state: "Aplikácia Controller stav relé",
    no_disconnector_selected: "Nie je vybraný žiaden disconnector",
    controller_timeline: "Aplikácia Controller časová os",
    rising_shapes: "Nábehové krivky spotrebičov",
    falling_shapes: "Dobehové krivky spotrebičov",
    firmware_upgrade: "Aktualizácia softvéru",
    firmware_up_to_date: "Softvér je aktuálny",
    firmware_upgrade_available: "K dispozícií nová verzia softvéru",
    firmware_not_available: "Aktualizácia nie je dostupná",
    settings: "Nastavenia",
    new_switch: "Nový vypínač",
    map: "Mapa",
    upload_new_map: "Nahraj svoju novú mapu",
    control_map: "Ovládacia mapa",
    uploading: "Nahráva sa",
    loading: "Načítava sa",
    notifications: "Notifikácie",
    add_notification_pair: "Pridaj notifikačný pár",
    paired_notifications: "Notifikačné páry",
    notify_device_status: "Status zariadenia",
    notify_anomaly: "Anomália",
    anomaly_models: "Anomálne modely",
    user_manager: "Aplikácia UserManager",
    select_group: "Skupina zariadeni"
}